import type { TrackableSurface } from "./eventNames";

/**
 * Maps each tracking surface to the admin-edit route for the
 * underlying record. Returning `null` means the surface has no
 * admin page yet and the analytics row should stay non-clickable.
 *
 * The numeric `entityId` here is the resolved primary key returned
 * by `/tracking/resolve-entities/`, never the raw Guid an
 * announcement event carries — for those, the resolver has already
 * mapped Notification.Id → Announcement.Id.
 */
export const adminRouteForSurface = (
	surface: TrackableSurface,
	entityId: number
): string | null => {
	switch (surface) {
		case "ANNOUNCEMENT":
			return `/announcements/${entityId}`;
		case "PROMOTION":
			return `/vendor-sponsorship/promotion/banners/new-promotion-form/${entityId}`;
		case "CAROUSEL":
			return `/vendor-sponsorship/homepage-carousel/banners/new-carousel-banner-form/${entityId}`;
		case "KEY_SHOUT":
			return `/app/homepage/key-shouts/${entityId}`;
		case "QUICK_LINK":
			return `/app/homepage/quick-links/${entityId}`;
		case "EVENT":
			return `/app/events/${entityId}`;
		case "TAKEOVER":
			return `/vendor-sponsorship/full-screen-takeover/banners/new-full-page-takeover-form/${entityId}`;
		case "NEWS":
			// News doesn't currently expose a per-article admin route.
			return null;
		default:
			return null;
	}
};
